import { render } from "./Pix.vue?vue&type=template&id=43143b7b&scoped=true"
import script from "./Pix.vue?vue&type=script&lang=js"
export * from "./Pix.vue?vue&type=script&lang=js"

import "./Pix.vue?vue&type=style&index=0&id=43143b7b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43143b7b"]])

export default __exports__